"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreatmentSubType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var TreatmentSubType_Factory = /** @class */ (function () {
    function TreatmentSubType_Factory() {
    }
    TreatmentSubType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            TreatmentAnatomyTypeCode: model.TreatmentAnatomyTypeCode,
            TreatmentSubTypeCode: model.TreatmentSubTypeCode,
            TreatmentTypeCode: model.TreatmentTypeCode,
        };
        return result;
    };
    TreatmentSubType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            TreatmentAnatomyTypeCode: model.TreatmentAnatomyTypeCode,
            TreatmentSubTypeCode: model.TreatmentSubTypeCode,
            TreatmentTypeCode: model.TreatmentTypeCode,
        };
        return result;
    };
    return TreatmentSubType_Factory;
}());
exports.TreatmentSubType_Factory = TreatmentSubType_Factory;
